"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentFrontPage = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _ContentRoot = require("../ContentRoot");
var _ContentText = require("../ContentText");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const ContentFrontPage = () => {
  const {
    frontpageContent
  } = (0, _hooks.useFooter)();
  const {
    isFrontPage
  } = (0, _hooks.useAppConfig)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!isFrontPage || !frontpageContent) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentRoot.ContentRoot, {
    testId: getTestId(_constants.CONTENT_FRONT_PAGE),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentText.ContentText, {
      children: frontpageContent
    })
  });
};
exports.ContentFrontPage = ContentFrontPage;
